import Link from 'next/link';
import { ReactNode } from 'react';

import { Box, Group, Stack, Text } from '@mantine/core';

import { FileIcon } from 'components/file-icon/FileIcon';

import cx from './FileTeaser.module.scss';

const FileTeaser = ({
    href,
    download,
    newTab,
    cover,
    shape = 'portrait',
    file,
    overlay,
    title,
    meta,
}: {
    href: string;
    download?: boolean;
    newTab?: boolean;
    cover: ReactNode;
    shape?: 'portrait' | 'landscape' | 'square';
    file?: { mimeType: string; filename: string } | null;
    overlay?: ReactNode;
    title?: ReactNode;
    meta?: ReactNode;
}) => {
    const content = (
        <>
            <Box className={cx.frame} data-shape={shape}>
                {cover}
                {overlay}
                {file && <FileTypeBadge mimeType={file.mimeType} filename={file.filename} />}
            </Box>
            {(title || meta) && (
                <Stack gap={0} mt="sm" px={2}>
                    {title && (
                        <Text fw={600} fz="sm" lineClamp={2}>
                            {title}
                        </Text>
                    )}
                    {meta && (
                        <Text fz="xs" c="dimmed" lineClamp={1}>
                            {meta}
                        </Text>
                    )}
                </Stack>
            )}
        </>
    );

    return download || newTab ? (
        <a href={href} download={download} target="_blank" rel="noopener noreferrer" className={cx.root}>
            {content}
        </a>
    ) : (
        <Link href={href} className={cx.root}>
            {content}
        </Link>
    );
};

const FileTypeBadge = ({ mimeType, filename }: { mimeType: string; filename: string }) => (
    <Group gap={4} wrap="nowrap" className={cx.badge}>
        <FileIcon mimeType={mimeType} size={12} />
        {filename.split('.').pop()?.toUpperCase()}
    </Group>
);

export { FileTeaser };
